import type { ModuleProps } from "../components/demo/ModuleCard";

export const demoModules: ModuleProps[] = [
    {
        id: "superz",
        name: "PIERRE",
        description: "Inteligência Artificial Generativa e Busca Semântica em tempo real.",
        status: "active",
        latency: 124,
        icon: "pierre",
        route: "/pierre"
    },
    {
        id: "ocr",
        name: "MINERVA",
        description: "Extração estruturada de documentos médicos e laudos.",
        status: "active",
        latency: 45,
        icon: "minerva",
        route: "/minerva"
    },
    {
        id: "hippocrates",
        name: "HIPÓCRATES",
        description: "Comunicação Ética e Humanizada.",
        status: "active",
        latency: 89,
        icon: "hippocrates",
        route: "/hippocrates"
    },
    {
        id: "oswaldo",
        name: "OSWALDO",
        description: "Gestão de crônicos e protocolos clínicos (SBN, ADA).",
        status: "active",
        latency: 68,
        icon: "oswaldo",
        route: "/oswaldo"
    },
    {
        id: "florence",
        name: "FLORENCE",
        description: "Análise clínica profunda e interpretação laboratorial.",
        status: "active",
        latency: 92,
        icon: "florence",
        route: "/florence"
    },
    {
        id: "wanda",
        name: "WANDA",
        description: "Sistematização da Assistência de Enfermagem (SAE).",
        status: "active",
        latency: 55,
        icon: "wanda",
        route: "/wanda"
    },
    {
        id: "nise",
        name: "NISE",
        description: "Gestão de fluxos e orquestração de processos (Kestra).",
        status: "active",
        latency: 210,
        icon: "nise",
        route: "/nise"
    },
    {
        id: "zilda",
        name: "ZILDA",
        description: "Dados de saúde pública (DATASUS, CNES) e território.",
        status: "active",
        latency: 180,
        icon: "zilda",
        route: "/zilda"
    },
    {
        id: "grahame",
        name: "GRAHAME",
        description: "Agente de Interoperabilidade FHIR (Padrão HL7).",
        status: "active",
        latency: 12,
        icon: "grahame",
        route: "/grahame"
    },
    {
        id: "geralda",
        name: "GERALDA",
        description: "Acompanhamento longitudinal e planos de cuidado.",
        status: "active",
        latency: 45,
        icon: "geralda",
        route: "/geralda"
    },
    {
        id: "donabedian",
        name: "DONABEDIAN",
        description: "Qualidade e Auditoria (Estrutura, Processo, Resultados).",
        status: "active",
        latency: 105,
        icon: "donabedian",
        route: "/donabedian"
    },
];
